import type { ActivityModule } from '../../core/activity';
import { mountLearnDecimalsSubtractions } from './ui';
import levelsData from './levels.json';
import '../learn_decimals/style.css';
import '../learn_decimals_additions/style.css';

export const learnDecimalsSubtractions: ActivityModule = {
  id: 'learn_decimals_subtractions',
  title: 'Subtraia decimais',
  description: 'Veja a subtração com decimais e pinte os décimos nas barras pra representar o resultado.',
  ageMin: 8,
  ageMax: 12,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/learn_decimals_subtractions/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountLearnDecimalsSubtractions,
};
